<template>
  <div class="index-about-us">
    <div class="container-md container-md-left">
      <div class="title">关于我们</div>
      <div class="content">
        <div class="about-content-title"></div>
        <div class="content-desc">上上签同业签证平台涵盖100+国家、全国各领区、各签证类型产品,支持电脑端、小程序端在线查看与订单管理,并提供API、H5等多种方式,满足不同类型的同业需求。多年深耕供应链,上上签成功打造强大的供应链体系,结合行业领先的科技创新能力,致力于成为合作伙伴最值得信赖的签证解决方案提供商。</div>
        <div class="content-btn">
          <router-link :to="{path: '/about-us'}" class="btn-lg is-round icon-more">查看详情
            <img class="active-image" src="https://o.666visa.cn/static/ssqpeer/homepage/icon-more-white.png">
            <img class="init-image" src="https://o.666visa.cn/static/ssqpeer/homepage/icon-more-active.png">
          </router-link>
        </div>
      </div>
    </div>
    <div class="container-md-right"></div>
  </div>
</template>
<script>
export default {
  name: 'index-about-us',
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.index-about-us{
  width: 1120px;
  position: relative;
  height: 547px;
  display: flex;
  flex-direction: row-reverse;
  margin: 0 auto;
  margin-top: 70px;
  .container-md{
    flex: 1;
    position: absolute;
    left: 0px;
    top: 0px;
    &::after{
      content: "ABOUT";
      position: absolute;
      left: 0;
      top: 0px;
      z-index: 0;
      font-size: 66px;
      line-height: 92px;
      color: rgba(47, 51, 61, 0.06);
    }
    
  }
  .title{
    font-size: 32px;
    line-height: 44px;
    font-weight: 500;
    color: #2F333D;
  }
  .content{
    margin-top: 34px;
    width: 480px;
    padding: 32px 32px 52px 32px;
    color: #2F333D;
    line-height: 32px;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px 0px rgba(154,197,255,0.32);
    border-radius: 4px;
    .about-content-title{
      width: 18px;
      height: 4px;
      background: #599FFF;
      margin-bottom: 20px;
    }
    .content-desc{
      font-size: 16px;
      line-height: 32px;
      margin-bottom: 24px;
    }
    .content-btn{
      .icon-more{
        height: 40px;
        font-size: 16px;
        padding: 0 32px;
        border-radius: 24px;
        color: #599FFF;
        border-color: #599FFF;
        border: 1px solid #599fff;
        align-items: center;
        display: inline-flex;
        .active-image{
          display: none;
        }
        .init-image,.active-image{
          width: 16px;
          height: 16px;
          margin-left: 8px;
        }
        &:hover{
          background:#599FFF ;
          color: #fff;
          .init-image{
            display: none;
          }
          .active-image{
            display: block;
          }
          
        }
      }
    }
  }
  .container-md-right{
      width: 820px;
      height: 520px;
      background: #fff url(https://o.666visa.cn/static/ssqpeer/homepage/homepage-2.png) no-repeat center/cover;
    }
}
</style>




// WEBPACK FOOTER //
// src/pages/index/components/index-about-us.vue